// extracted by mini-css-extract-plugin
export default {"item":"NavbarLink_item__qu3lb","link":"NavbarLink_link__+nrpY","active":"NavbarLink_active__NY9kZ"};